<template>
  <div class="wrapper">
    <div class="left-bar">
      <span
        v-for="storyName in storybookList"
        :key="storyName"
        class="item"
        :class="{ active: curTab === storyName }"
        @click="curTab = storyName"
      >
        {{ storyName }}
      </span>
    </div>
    <div class="content">
      <template v-for="storyName in storybookList" :key="storyName">
        <component
          v-show="storyName === curTab"
          :is="storybookComponents[storyName]"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useStore } from '@/store';
import UiButton from '@/stories/ui-button.vue';
import UiLabel from '@/stories/ui-label.vue';
import UiChevron from '@/stories/ui-chevron.vue';
import UiMenu from '@/stories/ui-menu.vue';
import UiSelect from '@/stories/ui-select.vue';
import UiTooltipIcon from '@/stories/ui-tooltip-icon.vue';
import UiInput from '@/stories/ui-input.vue';
import UiDatePicker from '@/stories/ui-date-picker.vue';
import UiChip from '@/stories/ui-chip.vue';
import UiInputTime from '@/stories/ui-input-time.vue';
import UiDateTimePicker from '@/stories/ui-date-time-picker.vue';
import UiInfo from '@/stories/ui-info.vue';
import UiCheckbox from '@/stories/ui-checkbox.vue';
import UiRadioGroup from '@/stories/ui-radio-group.vue';
import UiSwitcher from '@/stories/ui-switcher.vue';
import UiTextarea from '@/stories/ui-textarea.vue';
import UiIcon from '@/stories/ui-icon.vue';
import UiUpdateInfo from '@/stories/ui-update-info.vue';
import UiLogout from '@/stories/ui-logout.vue';
import UiNotFound from '@/stories/ui-not-found.vue';
import UiPeriodPicker from '@/stories/ui-period-picker.vue';
import UiPhoneInput from '@/stories/ui-phone-input.vue';
import UiTabs from '@/stories/ui-tabs.vue';
import UiPeriodPickerInput from '@/stories/ui-period-picker-input.vue';
import UiCopyInput from '@/stories/ui-copy-input.vue';
import UiCopyTextarea from '@/stories/ui-copy-textarea.vue';
import UiCountInput from '@/stories/ui-count-input.vue';
import UiCreateUrlTags from '@/stories/ui-create-url-tags.vue';
import UiTable from '@/stories/ui-table.vue';
import UiTreeview from '@/stories/ui-treeview.vue';

const storybookComponents: Record<string, object> = {
  UiButton,
  UiLabel,
  UiChevron,
  UiMenu,
  UiSelect,
  UiTooltipIcon,
  UiInput,
  UiDatePicker,
  UiChip,
  UiInputTime,
  UiDateTimePicker,
  UiInfo,
  UiCheckbox,
  UiRadioGroup,
  UiSwitcher,
  UiTextarea,
  UiIcon,
  UiUpdateInfo,
  UiLogout,
  UiNotFound,
  UiPeriodPicker,
  UiPeriodPickerInput,
  UiPhoneInput,
  UiTabs,
  UiCopyInput,
  UiCopyTextarea,
  UiCountInput,
  UiCreateUrlTags,
  UiTable,
  UiTreeview,
};

const storybookList = Object.keys(storybookComponents);
const curTab = ref(storybookList[0]);
const store = useStore();

onMounted(() => {
  store.setLoading(false);
});
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  height: 100%;
}

.left-bar {
  display: flex;
  flex-direction: column;
  padding: 16px;
  flex-basis: 200px;
  border-right: 1px solid var(--color-gray40);
  height: 100%;
  font-size: 18px;

  .item {
    cursor: pointer;
    margin-bottom: 8px;

    &.active {
      pointer-events: none;
      font-weight: bold;
    }
  }
}

.content {
  display: flex;
  padding: 16px;
  flex: 1;
}
</style>
